module.exports = __webpack_public_path__ + "static/media/base-tanque.7a1c7dba.png";